import { avatarLogoMap } from '@/constants';
import {
  EAddMemberRelationship,
  EPatientRelationship,
  TGender,
} from '../types';

export function getLogoPath(
  relationship: EPatientRelationship,
  gender: TGender
): string {
  const key =
    `${relationship}_${gender}` as `${EAddMemberRelationship}_${TGender}`;
  return avatarLogoMap[key] || ''; // Default logo if key not found
}
